// Global notification (snackbar) state.
//
// The single app-wide message channel, modeled on the local snackbar pattern
// that used to live in Secretary.vue. One <v-snackbar> in App.vue renders this;
// any component surfaces a message by dispatching an action here instead of
// inventing its own snackbar / inline text. Blocking dialogs are reserved for
// flows that must stop the user (e.g. signup OTP failure).

import { errorMessage } from '../utils/errorMessage'

const DEFAULT_TIMEOUT = 5000

export default {
    namespaced: true,
    state: () => ({
        show: false,
        text: '',
        color: 'info', // 'success' | 'info' | 'error'
        timeout: DEFAULT_TIMEOUT,
    }),
    mutations: {
        show(state, { text, color = 'info', timeout = DEFAULT_TIMEOUT }) {
            state.text = text
            state.color = color
            state.timeout = timeout
            state.show = true
        },
        setShow(state, value) {
            state.show = value
        },
    },
    actions: {
        // Explicit message: dispatch a string, or { text, color, timeout }.
        notify({ commit }, payload) {
            const opts = typeof payload === 'string' ? { text: payload } : payload
            commit('show', opts)
        },
        notifySuccess({ commit }, text) {
            commit('show', { text, color: 'success' })
        },
        notifyInfo({ commit }, text) {
            commit('show', { text, color: 'info' })
        },
        // Maps an axios error to a friendly, status-aware message.
        notifyError({ commit }, error) {
            commit('show', { text: errorMessage(error), color: 'error' })
        },
    },
}
